var map = {
	"./abacus.svg": "./src/blocks/icon/svg/abacus.svg",
	"./abandoned.svg": "./src/blocks/icon/svg/abandoned.svg",
	"./acorn.svg": "./src/blocks/icon/svg/acorn.svg",
	"./add-bag.svg": "./src/blocks/icon/svg/add-bag.svg",
	"./aid-kit.svg": "./src/blocks/icon/svg/aid-kit.svg",
	"./air-balloon.svg": "./src/blocks/icon/svg/air-balloon.svg",
	"./air-conditioning.svg": "./src/blocks/icon/svg/air-conditioning.svg",
	"./airbrush.svg": "./src/blocks/icon/svg/airbrush.svg",
	"./airplane-landing.svg": "./src/blocks/icon/svg/airplane-landing.svg",
	"./airplane-takeoff.svg": "./src/blocks/icon/svg/airplane-takeoff.svg",
	"./airplane.svg": "./src/blocks/icon/svg/airplane.svg",
	"./alarm.svg": "./src/blocks/icon/svg/alarm.svg",
	"./alien.svg": "./src/blocks/icon/svg/alien.svg",
	"./ambulance.svg": "./src/blocks/icon/svg/ambulance.svg",
	"./american-express.svg": "./src/blocks/icon/svg/american-express.svg",
	"./anchor.svg": "./src/blocks/icon/svg/anchor.svg",
	"./announce.svg": "./src/blocks/icon/svg/announce.svg",
	"./apartment.svg": "./src/blocks/icon/svg/apartment.svg",
	"./aperture.svg": "./src/blocks/icon/svg/aperture.svg",
	"./apple.svg": "./src/blocks/icon/svg/apple.svg",
	"./atom.svg": "./src/blocks/icon/svg/atom.svg",
	"./auto.svg": "./src/blocks/icon/svg/auto.svg",
	"./axis.svg": "./src/blocks/icon/svg/axis.svg",
	"./baby-book.svg": "./src/blocks/icon/svg/baby-book.svg",
	"./baby-bottle.svg": "./src/blocks/icon/svg/baby-bottle.svg",
	"./baby-mobile.svg": "./src/blocks/icon/svg/baby-mobile.svg",
	"./baby-monitor.svg": "./src/blocks/icon/svg/baby-monitor.svg",
	"./backpack.svg": "./src/blocks/icon/svg/backpack.svg",
	"./badge-1.svg": "./src/blocks/icon/svg/badge-1.svg",
	"./badge-2.svg": "./src/blocks/icon/svg/badge-2.svg",
	"./badge-3.svg": "./src/blocks/icon/svg/badge-3.svg",
	"./badge-4.svg": "./src/blocks/icon/svg/badge-4.svg",
	"./bag-return.svg": "./src/blocks/icon/svg/bag-return.svg",
	"./bag.svg": "./src/blocks/icon/svg/bag.svg",
	"./bag2.svg": "./src/blocks/icon/svg/bag2.svg",
	"./balance-scale.svg": "./src/blocks/icon/svg/balance-scale.svg",
	"./balloon.svg": "./src/blocks/icon/svg/balloon.svg",
	"./balloons.svg": "./src/blocks/icon/svg/balloons.svg",
	"./bandaid.svg": "./src/blocks/icon/svg/bandaid.svg",
	"./bandaids.svg": "./src/blocks/icon/svg/bandaids.svg",
	"./bar.svg": "./src/blocks/icon/svg/bar.svg",
	"./baseball.svg": "./src/blocks/icon/svg/baseball.svg",
	"./basket-ball.svg": "./src/blocks/icon/svg/basket-ball.svg",
	"./basket.svg": "./src/blocks/icon/svg/basket.svg",
	"./bathrobe.svg": "./src/blocks/icon/svg/bathrobe.svg",
	"./bathroom.svg": "./src/blocks/icon/svg/bathroom.svg",
	"./battery-full.svg": "./src/blocks/icon/svg/battery-full.svg",
	"./beaker.svg": "./src/blocks/icon/svg/beaker.svg",
	"./bear.svg": "./src/blocks/icon/svg/bear.svg",
	"./bell.svg": "./src/blocks/icon/svg/bell.svg",
	"./belt.svg": "./src/blocks/icon/svg/belt.svg",
	"./bicycle.svg": "./src/blocks/icon/svg/bicycle.svg",
	"./binoculars.svg": "./src/blocks/icon/svg/binoculars.svg",
	"./blazer.svg": "./src/blocks/icon/svg/blazer.svg",
	"./blush.svg": "./src/blocks/icon/svg/blush.svg",
	"./bomb.svg": "./src/blocks/icon/svg/bomb.svg",
	"./bonfire.svg": "./src/blocks/icon/svg/bonfire.svg",
	"./boots-2.svg": "./src/blocks/icon/svg/boots-2.svg",
	"./boots.svg": "./src/blocks/icon/svg/boots.svg",
	"./bowling-ball.svg": "./src/blocks/icon/svg/bowling-ball.svg",
	"./bowtie.svg": "./src/blocks/icon/svg/bowtie.svg",
	"./box-cutter.svg": "./src/blocks/icon/svg/box-cutter.svg",
	"./boxing-glove.svg": "./src/blocks/icon/svg/boxing-glove.svg",
	"./bra.svg": "./src/blocks/icon/svg/bra.svg",
	"./brain.svg": "./src/blocks/icon/svg/brain.svg",
	"./bread-slice.svg": "./src/blocks/icon/svg/bread-slice.svg",
	"./bread.svg": "./src/blocks/icon/svg/bread.svg",
	"./breakfast.svg": "./src/blocks/icon/svg/breakfast.svg",
	"./briefcase.svg": "./src/blocks/icon/svg/briefcase.svg",
	"./brush-2.svg": "./src/blocks/icon/svg/brush-2.svg",
	"./brush.svg": "./src/blocks/icon/svg/brush.svg",
	"./bucket-2.svg": "./src/blocks/icon/svg/bucket-2.svg",
	"./bucket.svg": "./src/blocks/icon/svg/bucket.svg",
	"./bug.svg": "./src/blocks/icon/svg/bug.svg",
	"./burger.svg": "./src/blocks/icon/svg/burger.svg",
	"./bus.svg": "./src/blocks/icon/svg/bus.svg",
	"./button.svg": "./src/blocks/icon/svg/button.svg",
	"./cable-car.svg": "./src/blocks/icon/svg/cable-car.svg",
	"./cake.svg": "./src/blocks/icon/svg/cake.svg",
	"./calculator.svg": "./src/blocks/icon/svg/calculator.svg",
	"./caliper.svg": "./src/blocks/icon/svg/caliper.svg",
	"./camera-1.svg": "./src/blocks/icon/svg/camera-1.svg",
	"./camera-2.svg": "./src/blocks/icon/svg/camera-2.svg",
	"./camera-3.svg": "./src/blocks/icon/svg/camera-3.svg",
	"./camera-lens.svg": "./src/blocks/icon/svg/camera-lens.svg",
	"./camera.svg": "./src/blocks/icon/svg/camera.svg",
	"./camping.svg": "./src/blocks/icon/svg/camping.svg",
	"./candy-cane.svg": "./src/blocks/icon/svg/candy-cane.svg",
	"./cap.svg": "./src/blocks/icon/svg/cap.svg",
	"./car-rental.svg": "./src/blocks/icon/svg/car-rental.svg",
	"./car.svg": "./src/blocks/icon/svg/car.svg",
	"./carabiner.svg": "./src/blocks/icon/svg/carabiner.svg",
	"./carrot.svg": "./src/blocks/icon/svg/carrot.svg",
	"./cart.svg": "./src/blocks/icon/svg/cart.svg",
	"./chainsaw.svg": "./src/blocks/icon/svg/chainsaw.svg",
	"./chart-1.svg": "./src/blocks/icon/svg/chart-1.svg",
	"./chart-2.svg": "./src/blocks/icon/svg/chart-2.svg",
	"./check.svg": "./src/blocks/icon/svg/check.svg",
	"./cheese.svg": "./src/blocks/icon/svg/cheese.svg",
	"./chef.svg": "./src/blocks/icon/svg/chef.svg",
	"./cherry.svg": "./src/blocks/icon/svg/cherry.svg",
	"./chicken.svg": "./src/blocks/icon/svg/chicken.svg",
	"./chisel.svg": "./src/blocks/icon/svg/chisel.svg",
	"./clamp-2.svg": "./src/blocks/icon/svg/clamp-2.svg",
	"./clamp.svg": "./src/blocks/icon/svg/clamp.svg",
	"./clapperboard.svg": "./src/blocks/icon/svg/clapperboard.svg",
	"./clip.svg": "./src/blocks/icon/svg/clip.svg",
	"./clipboard.svg": "./src/blocks/icon/svg/clipboard.svg",
	"./close.svg": "./src/blocks/icon/svg/close.svg",
	"./coat.svg": "./src/blocks/icon/svg/coat.svg",
	"./code.svg": "./src/blocks/icon/svg/code.svg",
	"./cog.svg": "./src/blocks/icon/svg/cog.svg",
	"./color-picker-2.svg": "./src/blocks/icon/svg/color-picker-2.svg",
	"./color-picker-3.svg": "./src/blocks/icon/svg/color-picker-3.svg",
	"./color-picker.svg": "./src/blocks/icon/svg/color-picker.svg",
	"./comb.svg": "./src/blocks/icon/svg/comb.svg",
	"./comment-1.svg": "./src/blocks/icon/svg/comment-1.svg",
	"./comment-2.svg": "./src/blocks/icon/svg/comment-2.svg",
	"./compass.svg": "./src/blocks/icon/svg/compass.svg",
	"./concierge.svg": "./src/blocks/icon/svg/concierge.svg",
	"./corndog.svg": "./src/blocks/icon/svg/corndog.svg",
	"./cost.svg": "./src/blocks/icon/svg/cost.svg",
	"./coupon.svg": "./src/blocks/icon/svg/coupon.svg",
	"./credit-card.svg": "./src/blocks/icon/svg/credit-card.svg",
	"./crib.svg": "./src/blocks/icon/svg/crib.svg",
	"./cricket.svg": "./src/blocks/icon/svg/cricket.svg",
	"./croissant.svg": "./src/blocks/icon/svg/croissant.svg",
	"./crosshair.svg": "./src/blocks/icon/svg/crosshair.svg",
	"./cupcake-2.svg": "./src/blocks/icon/svg/cupcake-2.svg",
	"./cupcake.svg": "./src/blocks/icon/svg/cupcake.svg",
	"./delta-credit-card.svg": "./src/blocks/icon/svg/delta-credit-card.svg",
	"./desktop.svg": "./src/blocks/icon/svg/desktop.svg",
	"./diaper.svg": "./src/blocks/icon/svg/diaper.svg",
	"./directions.svg": "./src/blocks/icon/svg/directions.svg",
	"./disabled.svg": "./src/blocks/icon/svg/disabled.svg",
	"./discover-credit-card.svg": "./src/blocks/icon/svg/discover-credit-card.svg",
	"./diving.svg": "./src/blocks/icon/svg/diving.svg",
	"./dna.svg": "./src/blocks/icon/svg/dna.svg",
	"./doctor.svg": "./src/blocks/icon/svg/doctor.svg",
	"./dollar-currency.svg": "./src/blocks/icon/svg/dollar-currency.svg",
	"./donut.svg": "./src/blocks/icon/svg/donut.svg",
	"./drafting-compass.svg": "./src/blocks/icon/svg/drafting-compass.svg",
	"./dress.svg": "./src/blocks/icon/svg/dress.svg",
	"./drill-2.svg": "./src/blocks/icon/svg/drill-2.svg",
	"./drill.svg": "./src/blocks/icon/svg/drill.svg",
	"./dumbbell.svg": "./src/blocks/icon/svg/dumbbell.svg",
	"./earth-quake.svg": "./src/blocks/icon/svg/earth-quake.svg",
	"./earth.svg": "./src/blocks/icon/svg/earth.svg",
	"./egg.svg": "./src/blocks/icon/svg/egg.svg",
	"./electricity-tower.svg": "./src/blocks/icon/svg/electricity-tower.svg",
	"./electricity.svg": "./src/blocks/icon/svg/electricity.svg",
	"./elevator.svg": "./src/blocks/icon/svg/elevator.svg",
	"./ellipsis-1.svg": "./src/blocks/icon/svg/ellipsis-1.svg",
	"./ellipsis-2.svg": "./src/blocks/icon/svg/ellipsis-2.svg",
	"./euro-currency.svg": "./src/blocks/icon/svg/euro-currency.svg",
	"./evaluative.svg": "./src/blocks/icon/svg/evaluative.svg",
	"./exposure.svg": "./src/blocks/icon/svg/exposure.svg",
	"./factory.svg": "./src/blocks/icon/svg/factory.svg",
	"./fax.svg": "./src/blocks/icon/svg/fax.svg",
	"./female-user.svg": "./src/blocks/icon/svg/female-user.svg",
	"./film-roll.svg": "./src/blocks/icon/svg/film-roll.svg",
	"./film-strip.svg": "./src/blocks/icon/svg/film-strip.svg",
	"./filter.svg": "./src/blocks/icon/svg/filter.svg",
	"./fire.svg": "./src/blocks/icon/svg/fire.svg",
	"./fish.svg": "./src/blocks/icon/svg/fish.svg",
	"./fitness-center.svg": "./src/blocks/icon/svg/fitness-center.svg",
	"./flag.svg": "./src/blocks/icon/svg/flag.svg",
	"./flame.svg": "./src/blocks/icon/svg/flame.svg",
	"./flashlight.svg": "./src/blocks/icon/svg/flashlight.svg",
	"./flooding.svg": "./src/blocks/icon/svg/flooding.svg",
	"./floor-plan.svg": "./src/blocks/icon/svg/floor-plan.svg",
	"./for-sale.svg": "./src/blocks/icon/svg/for-sale.svg",
	"./forklift.svg": "./src/blocks/icon/svg/forklift.svg",
	"./free-toiletries.svg": "./src/blocks/icon/svg/free-toiletries.svg",
	"./fries.svg": "./src/blocks/icon/svg/fries.svg",
	"./gallery.svg": "./src/blocks/icon/svg/gallery.svg",
	"./gamepad.svg": "./src/blocks/icon/svg/gamepad.svg",
	"./gas.svg": "./src/blocks/icon/svg/gas.svg",
	"./gaslamp.svg": "./src/blocks/icon/svg/gaslamp.svg",
	"./gauge.svg": "./src/blocks/icon/svg/gauge.svg",
	"./gavel.svg": "./src/blocks/icon/svg/gavel.svg",
	"./geek-hat.svg": "./src/blocks/icon/svg/geek-hat.svg",
	"./ghost.svg": "./src/blocks/icon/svg/ghost.svg",
	"./gift.svg": "./src/blocks/icon/svg/gift.svg",
	"./gingerbread-man.svg": "./src/blocks/icon/svg/gingerbread-man.svg",
	"./glasses-2.svg": "./src/blocks/icon/svg/glasses-2.svg",
	"./glasses.svg": "./src/blocks/icon/svg/glasses.svg",
	"./globe.svg": "./src/blocks/icon/svg/globe.svg",
	"./globe2.svg": "./src/blocks/icon/svg/globe2.svg",
	"./gloves.svg": "./src/blocks/icon/svg/gloves.svg",
	"./golf-ball.svg": "./src/blocks/icon/svg/golf-ball.svg",
	"./gopro.svg": "./src/blocks/icon/svg/gopro.svg",
	"./graduation-cap.svg": "./src/blocks/icon/svg/graduation-cap.svg",
	"./gurney.svg": "./src/blocks/icon/svg/gurney.svg",
	"./hairdryer.svg": "./src/blocks/icon/svg/hairdryer.svg",
	"./hand-truck.svg": "./src/blocks/icon/svg/hand-truck.svg",
	"./hanger.svg": "./src/blocks/icon/svg/hanger.svg",
	"./hard-drive.svg": "./src/blocks/icon/svg/hard-drive.svg",
	"./hat.svg": "./src/blocks/icon/svg/hat.svg",
	"./headphones.svg": "./src/blocks/icon/svg/headphones.svg",
	"./heating.svg": "./src/blocks/icon/svg/heating.svg",
	"./helicopter.svg": "./src/blocks/icon/svg/helicopter.svg",
	"./high-heels-2.svg": "./src/blocks/icon/svg/high-heels-2.svg",
	"./high-heels.svg": "./src/blocks/icon/svg/high-heels.svg",
	"./hoodie.svg": "./src/blocks/icon/svg/hoodie.svg",
	"./hospital-2.svg": "./src/blocks/icon/svg/hospital-2.svg",
	"./hospital.svg": "./src/blocks/icon/svg/hospital.svg",
	"./hot-dog.svg": "./src/blocks/icon/svg/hot-dog.svg",
	"./hourglass.svg": "./src/blocks/icon/svg/hourglass.svg",
	"./ice-cream-2.svg": "./src/blocks/icon/svg/ice-cream-2.svg",
	"./ice-cream-3.svg": "./src/blocks/icon/svg/ice-cream-3.svg",
	"./ice-cream.svg": "./src/blocks/icon/svg/ice-cream.svg",
	"./image.svg": "./src/blocks/icon/svg/image.svg",
	"./infinity.svg": "./src/blocks/icon/svg/infinity.svg",
	"./info.svg": "./src/blocks/icon/svg/info.svg",
	"./ipod.svg": "./src/blocks/icon/svg/ipod.svg",
	"./iron.svg": "./src/blocks/icon/svg/iron.svg",
	"./jcb-credit-card.svg": "./src/blocks/icon/svg/jcb-credit-card.svg",
	"./jerry-can.svg": "./src/blocks/icon/svg/jerry-can.svg",
	"./jewelry.svg": "./src/blocks/icon/svg/jewelry.svg",
	"./joystick.svg": "./src/blocks/icon/svg/joystick.svg",
	"./kayak.svg": "./src/blocks/icon/svg/kayak.svg",
	"./key.svg": "./src/blocks/icon/svg/key.svg",
	"./keyboard.svg": "./src/blocks/icon/svg/keyboard.svg",
	"./keys.svg": "./src/blocks/icon/svg/keys.svg",
	"./lamp.svg": "./src/blocks/icon/svg/lamp.svg",
	"./laptop.svg": "./src/blocks/icon/svg/laptop.svg",
	"./laundry.svg": "./src/blocks/icon/svg/laundry.svg",
	"./led.svg": "./src/blocks/icon/svg/led.svg",
	"./life-jacket.svg": "./src/blocks/icon/svg/life-jacket.svg",
	"./light-bulb.svg": "./src/blocks/icon/svg/light-bulb.svg",
	"./linens.svg": "./src/blocks/icon/svg/linens.svg",
	"./loading-2.svg": "./src/blocks/icon/svg/loading-2.svg",
	"./loading.svg": "./src/blocks/icon/svg/loading.svg",
	"./lounge.svg": "./src/blocks/icon/svg/lounge.svg",
	"./luggage-2.svg": "./src/blocks/icon/svg/luggage-2.svg",
	"./luggage.svg": "./src/blocks/icon/svg/luggage.svg",
	"./lungs.svg": "./src/blocks/icon/svg/lungs.svg",
	"./maestro-credit-card.svg": "./src/blocks/icon/svg/maestro-credit-card.svg",
	"./magnet.svg": "./src/blocks/icon/svg/magnet.svg",
	"./mail.svg": "./src/blocks/icon/svg/mail.svg",
	"./mannequin.svg": "./src/blocks/icon/svg/mannequin.svg",
	"./map-2.svg": "./src/blocks/icon/svg/map-2.svg",
	"./map.svg": "./src/blocks/icon/svg/map.svg",
	"./mask.svg": "./src/blocks/icon/svg/mask.svg",
	"./mastercard-card.svg": "./src/blocks/icon/svg/mastercard-card.svg",
	"./medal.svg": "./src/blocks/icon/svg/medal.svg",
	"./medical-phone.svg": "./src/blocks/icon/svg/medical-phone.svg",
	"./medical.svg": "./src/blocks/icon/svg/medical.svg",
	"./medicine.svg": "./src/blocks/icon/svg/medicine.svg",
	"./memory.svg": "./src/blocks/icon/svg/memory.svg",
	"./microphone.svg": "./src/blocks/icon/svg/microphone.svg",
	"./microscope.svg": "./src/blocks/icon/svg/microscope.svg",
	"./milk.svg": "./src/blocks/icon/svg/milk.svg",
	"./minibar.svg": "./src/blocks/icon/svg/minibar.svg",
	"./mixer.svg": "./src/blocks/icon/svg/mixer.svg",
	"./mobile-app.svg": "./src/blocks/icon/svg/mobile-app.svg",
	"./mobile-sync.svg": "./src/blocks/icon/svg/mobile-sync.svg",
	"./molecule.svg": "./src/blocks/icon/svg/molecule.svg",
	"./mortgage.svg": "./src/blocks/icon/svg/mortgage.svg",
	"./motorcycle.svg": "./src/blocks/icon/svg/motorcycle.svg",
	"./natural-energy.svg": "./src/blocks/icon/svg/natural-energy.svg",
	"./neutral-face.svg": "./src/blocks/icon/svg/neutral-face.svg",
	"./newspapers.svg": "./src/blocks/icon/svg/newspapers.svg",
	"./no-smoking.svg": "./src/blocks/icon/svg/no-smoking.svg",
	"./nurse.svg": "./src/blocks/icon/svg/nurse.svg",
	"./onesie.svg": "./src/blocks/icon/svg/onesie.svg",
	"./orange.svg": "./src/blocks/icon/svg/orange.svg",
	"./orbit.svg": "./src/blocks/icon/svg/orbit.svg",
	"./outlet.svg": "./src/blocks/icon/svg/outlet.svg",
	"./pacifier.svg": "./src/blocks/icon/svg/pacifier.svg",
	"./paperplane.svg": "./src/blocks/icon/svg/paperplane.svg",
	"./parfume.svg": "./src/blocks/icon/svg/parfume.svg",
	"./parking.svg": "./src/blocks/icon/svg/parking.svg",
	"./partial.svg": "./src/blocks/icon/svg/partial.svg",
	"./paypal.svg": "./src/blocks/icon/svg/paypal.svg",
	"./pear.svg": "./src/blocks/icon/svg/pear.svg",
	"./pencil.svg": "./src/blocks/icon/svg/pencil.svg",
	"./pentool.svg": "./src/blocks/icon/svg/pentool.svg",
	"./pets.svg": "./src/blocks/icon/svg/pets.svg",
	"./pie.svg": "./src/blocks/icon/svg/pie.svg",
	"./piggy-bank.svg": "./src/blocks/icon/svg/piggy-bank.svg",
	"./pill-2.svg": "./src/blocks/icon/svg/pill-2.svg",
	"./pill.svg": "./src/blocks/icon/svg/pill.svg",
	"./pin-2.svg": "./src/blocks/icon/svg/pin-2.svg",
	"./pin.svg": "./src/blocks/icon/svg/pin.svg",
	"./ping-pong.svg": "./src/blocks/icon/svg/ping-pong.svg",
	"./pizza.svg": "./src/blocks/icon/svg/pizza.svg",
	"./planet.svg": "./src/blocks/icon/svg/planet.svg",
	"./pliers.svg": "./src/blocks/icon/svg/pliers.svg",
	"./plug.svg": "./src/blocks/icon/svg/plug.svg",
	"./plus-circle.svg": "./src/blocks/icon/svg/plus-circle.svg",
	"./plus.svg": "./src/blocks/icon/svg/plus.svg",
	"./pocket-knife.svg": "./src/blocks/icon/svg/pocket-knife.svg",
	"./pocket-knife2.svg": "./src/blocks/icon/svg/pocket-knife2.svg",
	"./pointer.svg": "./src/blocks/icon/svg/pointer.svg",
	"./polaroid.svg": "./src/blocks/icon/svg/polaroid.svg",
	"./polygrip.svg": "./src/blocks/icon/svg/polygrip.svg",
	"./pool-ball.svg": "./src/blocks/icon/svg/pool-ball.svg",
	"./pool.svg": "./src/blocks/icon/svg/pool.svg",
	"./pound-currency.svg": "./src/blocks/icon/svg/pound-currency.svg",
	"./power-off.svg": "./src/blocks/icon/svg/power-off.svg",
	"./presentation.svg": "./src/blocks/icon/svg/presentation.svg",
	"./processor.svg": "./src/blocks/icon/svg/processor.svg",
	"./projector.svg": "./src/blocks/icon/svg/projector.svg",
	"./pulse.svg": "./src/blocks/icon/svg/pulse.svg",
	"./purse.svg": "./src/blocks/icon/svg/purse.svg",
	"./puzzle.svg": "./src/blocks/icon/svg/puzzle.svg",
	"./question.svg": "./src/blocks/icon/svg/question.svg",
	"./quiz.svg": "./src/blocks/icon/svg/quiz.svg",
	"./quote.svg": "./src/blocks/icon/svg/quote.svg",
	"./radio.svg": "./src/blocks/icon/svg/radio.svg",
	"./radioactive.svg": "./src/blocks/icon/svg/radioactive.svg",
	"./rattle.svg": "./src/blocks/icon/svg/rattle.svg",
	"./recycle-bin.svg": "./src/blocks/icon/svg/recycle-bin.svg",
	"./recycle.svg": "./src/blocks/icon/svg/recycle.svg",
	"./refreshment.svg": "./src/blocks/icon/svg/refreshment.svg",
	"./refrigerator.svg": "./src/blocks/icon/svg/refrigerator.svg",
	"./repair.svg": "./src/blocks/icon/svg/repair.svg",
	"./restaurant.svg": "./src/blocks/icon/svg/restaurant.svg",
	"./ribbon-2.svg": "./src/blocks/icon/svg/ribbon-2.svg",
	"./ribbon-3.svg": "./src/blocks/icon/svg/ribbon-3.svg",
	"./ribbon.svg": "./src/blocks/icon/svg/ribbon.svg",
	"./rocket.svg": "./src/blocks/icon/svg/rocket.svg",
	"./rocking-horse.svg": "./src/blocks/icon/svg/rocking-horse.svg",
	"./rollers.svg": "./src/blocks/icon/svg/rollers.svg",
	"./rope.svg": "./src/blocks/icon/svg/rope.svg",
	"./rubber-duck.svg": "./src/blocks/icon/svg/rubber-duck.svg",
	"./rugby-ball.svg": "./src/blocks/icon/svg/rugby-ball.svg",
	"./ruler.svg": "./src/blocks/icon/svg/ruler.svg",
	"./rupee-currency.svg": "./src/blocks/icon/svg/rupee-currency.svg",
	"./sad.svg": "./src/blocks/icon/svg/sad.svg",
	"./safe.svg": "./src/blocks/icon/svg/safe.svg",
	"./safety-pin.svg": "./src/blocks/icon/svg/safety-pin.svg",
	"./satellite-channels.svg": "./src/blocks/icon/svg/satellite-channels.svg",
	"./sausage.svg": "./src/blocks/icon/svg/sausage.svg",
	"./save.svg": "./src/blocks/icon/svg/save.svg",
	"./saw.svg": "./src/blocks/icon/svg/saw.svg",
	"./scarf.svg": "./src/blocks/icon/svg/scarf.svg",
	"./screwdriver.svg": "./src/blocks/icon/svg/screwdriver.svg",
	"./sd-card.svg": "./src/blocks/icon/svg/sd-card.svg",
	"./search.svg": "./src/blocks/icon/svg/search.svg",
	"./seashell.svg": "./src/blocks/icon/svg/seashell.svg",
	"./secure.svg": "./src/blocks/icon/svg/secure.svg",
	"./security.svg": "./src/blocks/icon/svg/security.svg",
	"./servers.svg": "./src/blocks/icon/svg/servers.svg",
	"./share.svg": "./src/blocks/icon/svg/share.svg",
	"./ship.svg": "./src/blocks/icon/svg/ship.svg",
	"./shirt.svg": "./src/blocks/icon/svg/shirt.svg",
	"./shovel-2.svg": "./src/blocks/icon/svg/shovel-2.svg",
	"./shovel.svg": "./src/blocks/icon/svg/shovel.svg",
	"./show.svg": "./src/blocks/icon/svg/show.svg",
	"./shower.svg": "./src/blocks/icon/svg/shower.svg",
	"./shuttle-service.svg": "./src/blocks/icon/svg/shuttle-service.svg",
	"./shuttlecock.svg": "./src/blocks/icon/svg/shuttlecock.svg",
	"./sitemap.svg": "./src/blocks/icon/svg/sitemap.svg",
	"./skating.svg": "./src/blocks/icon/svg/skating.svg",
	"./ski.svg": "./src/blocks/icon/svg/ski.svg",
	"./slice.svg": "./src/blocks/icon/svg/slice.svg",
	"./slippers.svg": "./src/blocks/icon/svg/slippers.svg",
	"./small-battery.svg": "./src/blocks/icon/svg/small-battery.svg",
	"./smart-watch.svg": "./src/blocks/icon/svg/smart-watch.svg",
	"./smile.svg": "./src/blocks/icon/svg/smile.svg",
	"./smoking.svg": "./src/blocks/icon/svg/smoking.svg",
	"./snowboard.svg": "./src/blocks/icon/svg/snowboard.svg",
	"./soccer-ball.svg": "./src/blocks/icon/svg/soccer-ball.svg",
	"./socks.svg": "./src/blocks/icon/svg/socks.svg",
	"./soda.svg": "./src/blocks/icon/svg/soda.svg",
	"./solar-panel.svg": "./src/blocks/icon/svg/solar-panel.svg",
	"./solo-credit-card.svg": "./src/blocks/icon/svg/solo-credit-card.svg",
	"./soundproof.svg": "./src/blocks/icon/svg/soundproof.svg",
	"./spa.svg": "./src/blocks/icon/svg/spa.svg",
	"./space-helmet.svg": "./src/blocks/icon/svg/space-helmet.svg",
	"./spade.svg": "./src/blocks/icon/svg/spade.svg",
	"./star.svg": "./src/blocks/icon/svg/star.svg",
	"./stethoscope.svg": "./src/blocks/icon/svg/stethoscope.svg",
	"./strawberry.svg": "./src/blocks/icon/svg/strawberry.svg",
	"./stroller.svg": "./src/blocks/icon/svg/stroller.svg",
	"./studio-light.svg": "./src/blocks/icon/svg/studio-light.svg",
	"./sun-deck.svg": "./src/blocks/icon/svg/sun-deck.svg",
	"./support.svg": "./src/blocks/icon/svg/support.svg",
	"./sustainability.svg": "./src/blocks/icon/svg/sustainability.svg",
	"./switch.svg": "./src/blocks/icon/svg/switch.svg",
	"./sync.svg": "./src/blocks/icon/svg/sync.svg",
	"./syringe.svg": "./src/blocks/icon/svg/syringe.svg",
	"./t-shirt.svg": "./src/blocks/icon/svg/t-shirt.svg",
	"./tag.svg": "./src/blocks/icon/svg/tag.svg",
	"./tap.svg": "./src/blocks/icon/svg/tap.svg",
	"./taxi.svg": "./src/blocks/icon/svg/taxi.svg",
	"./team.svg": "./src/blocks/icon/svg/team.svg",
	"./telephone.svg": "./src/blocks/icon/svg/telephone.svg",
	"./telescope.svg": "./src/blocks/icon/svg/telescope.svg",
	"./tennis-ball.svg": "./src/blocks/icon/svg/tennis-ball.svg",
	"./testube.svg": "./src/blocks/icon/svg/testube.svg",
	"./thermometer.svg": "./src/blocks/icon/svg/thermometer.svg",
	"./thermos.svg": "./src/blocks/icon/svg/thermos.svg",
	"./thumbs-down.svg": "./src/blocks/icon/svg/thumbs-down.svg",
	"./thumbs-up.svg": "./src/blocks/icon/svg/thumbs-up.svg",
	"./thunder.svg": "./src/blocks/icon/svg/thunder.svg",
	"./tie.svg": "./src/blocks/icon/svg/tie.svg",
	"./timer.svg": "./src/blocks/icon/svg/timer.svg",
	"./toaster.svg": "./src/blocks/icon/svg/toaster.svg",
	"./toilet.svg": "./src/blocks/icon/svg/toilet.svg",
	"./tools.svg": "./src/blocks/icon/svg/tools.svg",
	"./tooth.svg": "./src/blocks/icon/svg/tooth.svg",
	"./towels.svg": "./src/blocks/icon/svg/towels.svg",
	"./trailer.svg": "./src/blocks/icon/svg/trailer.svg",
	"./train.svg": "./src/blocks/icon/svg/train.svg",
	"./transport.svg": "./src/blocks/icon/svg/transport.svg",
	"./trash-bin.svg": "./src/blocks/icon/svg/trash-bin.svg",
	"./tree.svg": "./src/blocks/icon/svg/tree.svg",
	"./trophy.svg": "./src/blocks/icon/svg/trophy.svg",
	"./trousers.svg": "./src/blocks/icon/svg/trousers.svg",
	"./trowel.svg": "./src/blocks/icon/svg/trowel.svg",
	"./tulip.svg": "./src/blocks/icon/svg/tulip.svg",
	"./tv.svg": "./src/blocks/icon/svg/tv.svg",
	"./umbrella.svg": "./src/blocks/icon/svg/umbrella.svg",
	"./underwear-2.svg": "./src/blocks/icon/svg/underwear-2.svg",
	"./underwear.svg": "./src/blocks/icon/svg/underwear.svg",
	"./usb-2.svg": "./src/blocks/icon/svg/usb-2.svg",
	"./usb-stick.svg": "./src/blocks/icon/svg/usb-stick.svg",
	"./usb.svg": "./src/blocks/icon/svg/usb.svg",
	"./user.svg": "./src/blocks/icon/svg/user.svg",
	"./users.svg": "./src/blocks/icon/svg/users.svg",
	"./verified.svg": "./src/blocks/icon/svg/verified.svg",
	"./vespa.svg": "./src/blocks/icon/svg/vespa.svg",
	"./video-camera-1.svg": "./src/blocks/icon/svg/video-camera-1.svg",
	"./video-camera-2.svg": "./src/blocks/icon/svg/video-camera-2.svg",
	"./video-camera-3.svg": "./src/blocks/icon/svg/video-camera-3.svg",
	"./video-camera-4.svg": "./src/blocks/icon/svg/video-camera-4.svg",
	"./video-card.svg": "./src/blocks/icon/svg/video-card.svg",
	"./villa.svg": "./src/blocks/icon/svg/villa.svg",
	"./visa-credit-card.svg": "./src/blocks/icon/svg/visa-credit-card.svg",
	"./visa-electron.svg": "./src/blocks/icon/svg/visa-electron.svg",
	"./volley-ball.svg": "./src/blocks/icon/svg/volley-ball.svg",
	"./volume.svg": "./src/blocks/icon/svg/volume.svg",
	"./wallet.svg": "./src/blocks/icon/svg/wallet.svg",
	"./water-supply.svg": "./src/blocks/icon/svg/water-supply.svg",
	"./watermill.svg": "./src/blocks/icon/svg/watermill.svg",
	"./webcam.svg": "./src/blocks/icon/svg/webcam.svg",
	"./wheelbarrow.svg": "./src/blocks/icon/svg/wheelbarrow.svg",
	"./wifi.svg": "./src/blocks/icon/svg/wifi.svg",
	"./wind-turbine.svg": "./src/blocks/icon/svg/wind-turbine.svg",
	"./windmill.svg": "./src/blocks/icon/svg/windmill.svg",
	"./winter-hat.svg": "./src/blocks/icon/svg/winter-hat.svg",
	"./wrench.svg": "./src/blocks/icon/svg/wrench.svg",
	"./yen-currency.svg": "./src/blocks/icon/svg/yen-currency.svg",
	"./zoom-in.svg": "./src/blocks/icon/svg/zoom-in.svg",
	"./zoom-out.svg": "./src/blocks/icon/svg/zoom-out.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/blocks/icon/svg sync recursive ^\\.\\/.*\\.svg$";